export function equals(expr1, expr2) {
    return { op: 'equals', expr1, expr2 };
}
export function or(...exprs) {
    if (exprs.length == 0) {
        throw new Error('0 arguments pass to or()');
    }
    if (exprs.length == 1) {
        return exprs[0];
    }
    const op = {
        op: 'or',
        expr1: exprs.shift(),
        expr2: exprs.length > 1 ? or(...exprs) : exprs[0]
    };
    return op;
}
export function and(...exprs) {
    if (exprs.length == 0) {
        throw new Error('0 arguments pass to and()');
    }
    if (exprs.length == 1) {
        return exprs[0];
    }
    const op = {
        op: 'and',
        expr1: exprs.shift(),
        expr2: exprs.length > 1 ? and(...exprs) : exprs[0]
    };
    return op;
}
